<template>
    <v-card class="pa-3" height="100%">
        <apexchart
            ref="barchart"
            type="bar"
            height="350"
            :options="chart.earning.options"
            :series="chart.earning.series"
        ></apexchart>
    </v-card>
</template>
<script>
    import { mapGetters } from "vuex";  
    import VueApexCharts from "vue-apexcharts";

    export default {
    components: {
        apexchart: VueApexCharts,
    },
    data: () => ({
      chart: {
            earning: {
                series: [],
                options: {
                title: {
                    text: "Coins Earning Overview",
                },
                noData: {
                    text: "No data available",
                },
                chart: {
                    type: "bar",
                    toolbar: {
                        show: true,
                    },
                },
                xaxis: {
                    categories: [],
                },
                yaxis: [
                {
                    axisTicks: {
                        show: true,
                    },
                    axisBorder: {
                        show: true,
                        color: "#008FFB",
                    },
                    labels: {
                        style: {
                            colors: "#008FFB",
                        },
                    },
                    // title: {
                    //     text: "Amount of Earned (Coins)",
                    //     style: {
                    //         color: "#008FFB",
                    //     },
                    // },
                    tooltip: {
                        enabled: true,
                    },
                },
                // {
                //     opposite: true,
                //     axisTicks: {
                //         show: true,
                //     },
                //     axisBorder: {
                //         show: true,
                //         color: "#00E396",
                //     },
                //     labels: {
                //         style: {
                //             colors: "#00E396",
                //         },
                //     },
                //     title: {
                //         text: "Withdrawn Amount (Coins)",
                //         style: {
                //             color: "#00E396",
                //         },
                //     },
                // },
                ],
                dataLabels: {
                    enabled: false,
                },
            },
        },
      }

    }),

    created() {
      this.fetchReport();
    },

    computed: {
      ...mapGetters(["isLoggedIn","indexData"]),
    },

    methods: {
      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["earn-withdrawn"]);
        this.updateCharts();
      },

      async updateCharts() {  
        // Coin Earing Overview graph
        this.chart.earning.series = this.indexData.earning_overview.series;
        this.chart.earning.options = {
          xaxis: {
            categories: this.indexData.earning_overview.categories,
            type: "datetime",
          },
        };
      }
    }

  };
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
    z-index: -1;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0 !important;
  }
</style>